/** @jsx builderX.jsx */
import { builderX, Sprite, Image } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='numbers'>
    <Image src='0'/>
    <Image src='1'/>
    <Image src='2'/>
    <Image src='3'/>
    <Image src='4'/>
    <Image src='6'/>
    <Image src='7'/>
    <Image src='8'/>
    <Image src='9'/>
    <Image src='+'/>
    <Image src='5'/>
</Sprite>;
